import script from "./JaContentFrameSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./JaContentFrameSelect.vue?vue&type=script&setup=true&lang=js"

import "./JaContentFrameSelect.vue?vue&type=style&index=0&id=f21f829c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f21f829c"]])

export default __exports__